/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 */

import React from 'react';

// export default RuxinglunKepan;
// import * as queryString from 'query-string';

import {GroupedKepanTree} from 'templates/components/Kepan';
import Layout from 'components/Layout';
import Container from 'components/Container';
import { sharedStyles } from 'theme';
import originalKepanTree from './kepan_all-new.json';
import kepanPaths from './kepan_all-new-paths.json';
// import verseOptions from './kepan_all-new-options.json';
import verseList from './kepan_all-new-keys.json';
// import { VirtualizedVerseOptions } from './selection-options';

import chapterOneVerseOptions from './kepan_1-new-options.json';
import chapterTwoVerseOptions from './kepan_2-new-options.json';
import chapterThreeVerseOptions from './kepan_3-new-options.json';
import chapterFourVerseOptions from './kepan_4-new-options.json';
import chapterFiveVerseOptions from './kepan_5-new-options.json';
import chapterSixVerseOptions from './kepan_6-new-options.json';
import chapterSevenVerseOptions from './kepan_7-new-options.json';
import chapterEightVerseOptions from './kepan_8-new-options.json';
import chapterNineVerseOptions from './kepan_9-new-options.json';
import chapterTenVerseOptions from './kepan_10-new-options.json';
const groupedVerseOptions = [
  {
    label: '第一品、菩提心利益',
    options: chapterOneVerseOptions,
  },
  {
    label: '第二品、忏悔罪业',
    options: chapterTwoVerseOptions,
  },
  {
    label: '第三品、受持菩提心',
    options: chapterThreeVerseOptions,
  },
  {
    label: '第四品、不放逸',
    options: chapterFourVerseOptions,
  },
  {
    label: '第五品、正知正念',
    options: chapterFiveVerseOptions,
  },
  {
    label: '第六品、安忍',
    options: chapterSixVerseOptions,
  },
  {
    label: '第七品、精进',
    options: chapterSevenVerseOptions,
  },
  {
    label: '第八品、静虑',
    options: chapterEightVerseOptions,
  },
  {
    label: '第九品、智慧',
    options: chapterNineVerseOptions,
  },
  {
    label: '第十品、回向',
    options: chapterTenVerseOptions,
  },
];

const name = '入行论';
const defaultKepanPaths = [
  '入行论',
  '甲二、议义', '乙二、所入之自性', '丙二、入者之意乐', '丁二、受持之方法', '戊二、论义', '已一、加行：一、续中事宜；二、为利他而修心', '庚一、净化自相续',
  '丙三、趋入之方法',
  '乙三、圆满结尾',
];
const DEFAULT_EXPANSION_DEPTH = 4;

class RuxinglunKepan extends React.PureComponent {

  // /**
  //  * handle router query
  //  *  - if verse included, then display kepan
  //  */
  // componentDidMount() {
  //   const queryParams = queryString.parse(this.props.location.search);
  //   const verse = queryParams.verse;
  //   if (verse && verseList.includes(verse)) {
  //     this.showVerseKepan({value: verse, label: verse});
  //   }
  // }

  render() {
    const {location} = this.props;

    return (
      <Layout location={location}>
        <Container>
          <div css={sharedStyles.articleLayout.container}>
            <div css={sharedStyles.articleLayout.content} >
              <GroupedKepanTree
                originalKepanTree={originalKepanTree}
                name={name}
                DEFAULT_EXPANSION_DEPTH={DEFAULT_EXPANSION_DEPTH}
                defaultKepanPaths={defaultKepanPaths}
                kepanPaths={kepanPaths}
                verseList={verseList}
                groupedVerseOptions={groupedVerseOptions}
              />
            </div >
          </div>
        </Container>
      </Layout>
    );
  } // end of render

}

export default RuxinglunKepan;

